import { useEffect, useState } from "react"
import moment from "moment";
import { changeDateLastTwoMonthsChart, getHeartStatsLastTwoMonths, getHeartStatsLastYearsPerMonth, changeDateLastYearsChart, getHeartStatsLasTwoMonthsPerDay, changeDateLastPerDayInMonth } from "redux/reducers/heartDataReducer"
import { lastTwoMonths, lastYearsPerMonth } from "resources/ParametersTypes";
import LineChartDateArrows from "components/Charts/LineChartDateArrows";
import { Dashboard } from "locale/es";
import { useDispatch, useSelector } from "react-redux";

const PerDayMinAndMaxFrequencyInMonth = () => {
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString())

  const patientId = useSelector(({ patient }) => patient.id)
  const { data, status } = useSelector(({ heartData }) => heartData.lastTwoMonthsPerDayInMonthPatientData)
  const chartData = useSelector(({ heartData }) => heartData.perDayChartMinAndMaxFrequencyInMonth)

  const dispatch = useDispatch()

  useEffect(() => {
    if (patientId && selectedDate) {
      dispatch(getHeartStatsLasTwoMonthsPerDay(patientId, selectedDate));
    }
  }, [patientId, selectedDate, dispatch]);

  useEffect(() => {
    if (patientId && !!selectedDate && !!status) {
      dispatch(changeDateLastPerDayInMonth(selectedDate))
    }
  }, [data, dispatch, patientId, selectedDate, status])

  return (
    <LineChartDateArrows
      dataToShow={chartData}
      title={Dashboard.HEART_MIN_MAX_DAY}
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
      minDate={lastYearsPerMonth}
      maxDate={moment()}
      interval={'month'}
    />
  )
}

export default PerDayMinAndMaxFrequencyInMonth